module.exports = "/_next/static/images/3787f9ace255868fbc14758c51b1413a-woman-with-sandwich@2x.jpg";